import { Module } from "vuex";
import {
  deleteOneOrgMemberExternalDelete,
  deleteOrgMembersDelete,
  getCurrentUser,
  getOrgAccessGrantedToOther,
  getOrgDetails,
  getOrgMembersAddable,
  getOrgProfile,
  getOrgVerify,
  getSwitchOrgs,
  postOrgMembersDeactivate,
  postSwitchOrg,
  putOrgMembersActivate,
  resetMfaOrgMembers,
  resetPasswordOrgMembers,
  postOrgVerifiCallback,
  resetMfaPasskeyOrgMembers,
  getProfileImage,
  postOrgProfile,
  getParentOrg,
  getOrgIdProfile,
  getRoleByUserId,
  getPermissionLevelDetailsOfRoleType,
  postSwitchToHomeOrg,
  getOrgRoles,
  restoreUser,
} from "@/services/org";
import store, { RootState } from "..";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import { IOrgAccessType, IOrgDetails } from "@/interfaces/orgInterfaces";
import { Org, UserRoute, homeRoute } from "@/services/apiRoutes/routes";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { getImageData } from "@/utils/utilities";
import { getComponentUiText } from "@/utils/utilities";
import { IPlanDetails } from "@/interfaces/org/subscription";
import router from "@/router";
import { IgetOrgSubsPlanRespoinse } from "@/interfaces/subscipsions/subscriptionsInterfaces";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import get from "lodash/get";
import { IOrgRole } from "@/interfaces/org/role";

interface OrgModuleState {
  currentOrg: Record<string, any>;
  currentOrgProfile: Record<string, any>;
  orgsList: any[];
  addableOrgsList: any[];
  grantedOrgsList: any[];
  orgListVerify: any[];
  urlAvatar: any;
  currentOrgPlanDetails: IPlanDetails;
  currentParentOrg: any;
  originOrgsList: any[];
  isLoadingOrg: boolean;
  isStatusCappApiCheckParent: boolean;
  listRolesByUser: any[];
  maximunPermissionLevelData: {
    permissionLevelId: string;
    permissionLevelValue: number;
    permissionLevel: string;
    permissionLevelDescription: null | string;
    permissionLevelNotes: null | string;
    roleType: string;
    roleTypeId: string;
  };
  orgRoles: IOrgRole[];
  orgAccessType: IOrgAccessType[];
  invalidDomains: string[];
  currentOrgSecretRequired: object;
}

const orgModule: Module<OrgModuleState, RootState> = {
  namespaced: true,

  state: () => ({
    currentOrg: {},
    currentOrgProfile: {},
    orgsList: [],
    addableOrgsList: [],
    grantedOrgsList: [],
    orgListVerify: [],
    urlAvatar: null,
    currentOrgPlanDetails: {} as IPlanDetails,
    currentParentOrg: {},
    originOrgsList: [],
    isLoadingOrg: false,
    isStatusCappApiCheckParent: false,
    listRolesByUser: [],
    maximunPermissionLevelData: {
      permissionLevelId: "",
      permissionLevelValue: 0,
      permissionLevel: "",
      permissionLevelDescription: null,
      permissionLevelNotes: null,
      roleType: "",
      roleTypeId: "",
    },
    orgRoles: [],
    orgAccessType: [],
    invalidDomains: [],
    currentOrgSecretRequired: {},
  }),

  getters: {
    getOrgDetails: (state) => state.currentOrg,
    getOrgProfile: (state) => state.currentOrgProfile,
    getAddableOrgs: (state) => state.addableOrgsList,
    getGrantedOrgs: (state) => state.grantedOrgsList,
    getPlanDetails: (state) => {
      return state.currentOrgPlanDetails;
    },
    getCurrentOrg: (state) => {
      const output = state.orgsList.find(
        (item) => item.id === state.currentOrg.id,
      );
      return output || state.currentOrg;
    },
    getOrgAccessType: (state) => state.orgAccessType,
    getOrgDomainsInvalid: (state) => state.invalidDomains,
    getOrgRolesData: (state) => state.orgRoles,
  },

  mutations: {
    SET_ORG_ROLES: (state, orgRoles) => {
      state.orgRoles = orgRoles;
    },
    SET_CURRENT_ORG: (state, org) => {
      state.currentOrg = org;
      localStorage.setItem(localStorageKey.currentOrgData, JSON.stringify(org));
    },
    SET_ORG_ACCESS_TYPE: (state, orgAccessType) => {
      state.orgAccessType = orgAccessType;
    },
    SET_ORG_INVALID_DOMAINS: (state, invalidDomains) => {
      state.invalidDomains = invalidDomains;
    },
    SET_CURRENT_ROLES_BY_USER: (state, listRoles) => {
      state.listRolesByUser = listRoles;
    },
    SET_CURRENT_ORG_PROFILE: (state, data) => {
      state.currentOrgProfile = data;
    },
    SET_ORGS_LIST: (state, orgs) => {
      state.orgsList = orgs;
    },
    SET_ORIGIN_ORGS_LIST: (state, orgs) => {
      state.originOrgsList = orgs;
    },
    SET_ADDABLE_ORGS_LIST: (state, orgs) => {
      state.addableOrgsList = orgs;
    },
    SET_GRANTED_ORGS_LIST: (state, orgs) => {
      state.grantedOrgsList = orgs;
    },
    SET_URL_AVATAR: (state, urlAvatar) => {
      state.urlAvatar = urlAvatar;
    },
    SET_DELETE_CURRENT_AVATAR: (state, currentOrg) => {
      state.currentOrg.img = null;
      state.orgsList.forEach((e) => {
        if (e.id === currentOrg) {
          e.img = null;
        }
      });
    },
    SET_DELETE_CURRENT_LOGO: (state, IdCurrentOrg) => {
      if (IdCurrentOrg == state.currentParentOrg) {
        state.currentParentOrg.imgLogo = null;
      }
    },
    SET_CURRENT_AVATAR: (state, currentOrg) => {
      state.currentOrg.imgFile = currentOrg.imgFile;
      state.currentOrg.img = currentOrg.img;
      state.orgsList.forEach((e) => {
        if (e.id === currentOrg.orgId) {
          e.img = currentOrg.img;
        }
      });
    },
    SET_CURRENT_PARENT_ORG: (state, currentParentOrg) => {
      state.currentParentOrg = currentParentOrg;
    },
    SET_LOADING: (state, isLoadingOrg) => {
      state.isLoadingOrg = isLoadingOrg;
    },
    SET_STATUS_CALL_API_CHECK_PARENT: (state, isStatus) => {
      state.isStatusCappApiCheckParent = isStatus;
    },
    SET_CURRENT_ORG_PLAN_DETAILS: (
      state: any,
      value: IgetOrgSubsPlanRespoinse,
    ) => {
      if (value && Object.keys(value).length > 0 && value.planId) {
        state.currentOrgPlanDetails = value;
        localStorage.setItem(
          localStorageKey.isOrgPlanDetails,
          localStorageBoolean.true,
        );
      } else {
        state.currentOrgPlanDetails = null;
        localStorage.setItem(
          localStorageKey.isOrgPlanDetails,
          localStorageBoolean.false,
        );
      }
    },
    SET_CURRENT_ORG_ON_INIT: (state: any, value: IgetOrgSubsPlanRespoinse) => {
      const currentOrgData = { ...state.currentOrg, planDetails: value };
      state.currentOrg = value;
      localStorage.setItem(
        localStorageKey.currentOrgData,
        JSON.stringify(currentOrgData),
      );
    },
  },

  actions: {
    setCurrentOrg: async ({ commit, state }, tempOrg) => {
      const currentUserData = await getCurrentUser();
      const currentUser = currentUserData.data?.data;

      const img = state.currentOrg.img;
      const finalOrg = {
        ...tempOrg,
        img,
        id: tempOrg.orgId,
        name: tempOrg.nameShort,
        icon:
          tempOrg?.profileData?.avatarImageId[0] || "/img/activeOrg_icon.svg",
        isHome: currentUser?.orgId
          ? currentUser?.orgId === tempOrg.orgId
          : state.currentOrg.isHome,
        planDetails: state.currentOrg.planDetails,
        profileData: {
          avatarImageId: tempOrg?.profileData?.avatarImageId[0]?.id,
        },
      };
      commit("SET_CURRENT_ORG", finalOrg);
    },
    setOrgAccessType: async ({ commit }, orgAccessType) => {
      commit("SET_ORG_ACCESS_TYPE", orgAccessType);
    },
    setOrgInvalidDomains: async ({ commit }, invalidDomains) => {
      commit("SET_ORG_INVALID_DOMAINS", invalidDomains);
    },
    setCurrentOrgPlanDetailsOnInit: async ({ commit }, planDetails) => {
      commit("SET_CURRENT_ORG_ON_INIT", planDetails);
    },
    setOrgsList: ({ commit }, orgs) => {
      commit("SET_ORGS_LIST", orgs);
    },
    setAddableOrgsList: ({ commit }, orgs) => {
      commit("SET_ADDABLE_ORGS_LIST", orgs);
    },
    switchOrg: async (
      { commit, state },
      { orgId, isHomeOrg = false }: { orgId: string; isHomeOrg: boolean },
    ) => {
      try {
        let postRes;
        localStorage.removeItem(localStorageKey.rootChecklistReportId);
        localStorage.removeItem(localStorageKey.checklistReportId);
        store.commit("Assessment/INITIAL_CHANGE_ORG_USER");
        store.commit("Recommend/INITIAL_CHANGE_ORG_USER");
        store.commit("Sharing/INITIAL_CHANGE_ORG_USER");

        if (isHomeOrg) {
          postRes = await postSwitchToHomeOrg();
        } else {
          postRes = await postSwitchOrg(orgId);
        }
        const orgProfileRes: any = await getOrgProfile();
        const orgProfileData = {
          ...postRes.data?.data,
          ...orgProfileRes.data?.data,
        };
        const planDetails = orgProfileData?.planDetails;
        commit("SET_CURRENT_ORG_PLAN_DETAILS", planDetails);
        if (!planDetails || !planDetails.planId) {
          router.push({ path: homeRoute.homePage });
          return;
        }
        if (orgProfileData.orgId) {
          try {
            const orgResponse = await getOrgDetails(orgProfileData.orgId);
            const currentOrgSecretRequired = {
              secretRequiredChecklistRequested: !get(
                orgResponse,
                "data.data.secretDisabledChecklistRequested",
                true,
              ),
              secretRequiredPasswordReset: !get(
                orgResponse,
                "data.data.secretDisabledPasswordReset",
                true,
              ),
            };
            state.currentOrgSecretRequired = currentOrgSecretRequired;
            const tempOrg: any = orgResponse.data.data;
            const avatarImageId = orgProfileData?.avatar?.avatarImageFileId;
            const finalOrg = {
              ...tempOrg,
              id: tempOrg.orgId,
              name: tempOrg.nameShort,
              icon:
                tempOrg?.profileData?.avatarImageId ||
                "/img/activeOrg_icon.svg",
              isHome: false, // fake isHome until we get the real value from the API
              logoImageFileId:
                orgProfileData?.logosm?.logoSmImageFileId ||
                orgProfileData?.logolg?.logoLgImageFileId,
              avatarImageId,
              orgBio: orgProfileData?.orgBio,
            };
            if (finalOrg?.avatarImageId) {
              const res = await getProfileImage(finalOrg.avatarImageId);
              const imageDetails = res.data.data;
              const img = await getImageData(imageDetails);
              finalOrg.img = URL.createObjectURL(img);
            }
            commit("SET_CURRENT_ORG", finalOrg);
            if (avatarImageId) {
              commit("SET_URL_AVATAR", finalOrg.img);
            } else {
              commit("SET_URL_AVATAR", null);
            }
            // Get profile image for each org
            const promises = state.originOrgsList.map(async (org) => {
              if (
                org?.profileData?.avatarImageId &&
                org.id !== finalOrg.orgId
              ) {
                try {
                  const res = await getProfileImage(
                    org.profileData.avatarImageId,
                    org.id == state.currentOrg.orgId ? null : org.id,
                  );
                  const imageDetails = res.data.data;
                  const imgBlob = await getImageData(imageDetails);
                  org.img = URL.createObjectURL(imgBlob);
                } catch (error) {
                  console.log("error", error);
                }
              }
              if (org.id == finalOrg.orgId) {
                org.img = finalOrg.img;
              }
            });
            await Promise.all(promises);
            // Set parent org data
            if (finalOrg?.idParentOrg) {
              const currentParentOrg = state.originOrgsList.find(
                (org) => org.id === finalOrg.idParentOrg,
              );
              // const listOrg = formattedOrgList.filter(
              //   (org) => org.id !== currentOrg.idParentOrg,
              // );
              commit("SET_CURRENT_PARENT_ORG", currentParentOrg);
            } else {
              commit("SET_ORGS_LIST", state.originOrgsList);
              commit("SET_CURRENT_PARENT_ORG", {});
            }
          } catch (error: any) {
            showErrorAPI(error, Org.getOrgProfile);
          }
        }
        return true;
      } catch (error: any) {
        if (error == null) {
          router.push({ path: homeRoute.homePage });
          store.dispatch("Org/fetchOrgList");
          return;
        }
        const res: any = await postSwitchOrg(state.currentOrg.id);
        if (res?.data?.data?.planDetails) {
          commit("SET_CURRENT_ORG_PLAN_DETAILS", res.data.data.planDetails);
        }
        showErrorAPI(error, Org.switchOrg);
        return true;
      } finally {
        await store.dispatch("Sharing/resetSharingStore");
      }
    },
    refreshOrg: async ({ commit, state }) => {
      try {
        const orgProfile: any = await getOrgProfile();
        const orgProfileData = orgProfile.data?.data;
        if (orgProfileData.orgId) {
          commit("SET_CURRENT_ORG_PROFILE", orgProfileData);
          try {
            const orgResponse = await getOrgDetails(orgProfileData.orgId);
            const currentOrgSecretRequired = {
              secretRequiredChecklistRequested: !get(
                orgResponse,
                "data.data.secretDisabledChecklistRequested",
                true,
              ),
              secretRequiredPasswordReset: !get(
                orgResponse,
                "data.data.secretDisabledPasswordReset",
                true,
              ),
            };
            state.currentOrgSecretRequired = currentOrgSecretRequired;
            const tempOrg: any = orgResponse.data.data;
            const avatarImageId = orgProfileData?.avatar?.avatarImageFileId;
            const finalOrg = {
              ...tempOrg,
              id: tempOrg.orgId,
              name: tempOrg.nameShort,
              icon:
                tempOrg?.profileData?.avatarImageId ||
                "/img/activeOrg_icon.svg",
              isHome: state.currentOrg.isHome,
              logoImageFileId:
                orgProfileData?.logosm?.logoSmImageFileId ||
                orgProfileData?.logolg?.logoLgImageFileId,
              avatarImageId,
            };

            if (
              finalOrg?.avatarImageId &&
              ((!finalOrg.img &&
                finalOrg?.avatarImageId !==
                  state.currentOrg.profileData?.avatarImageId) ||
                !state.currentOrg.img)
            ) {
              const res = await getProfileImage(finalOrg?.avatarImageId);
              const imageDetails = res.data.data;
              const imgFile = await getImageData(imageDetails);
              const imgURL = URL.createObjectURL(imgFile);
              commit("SET_URL_AVATAR", imgURL);
              commit("SET_CURRENT_AVATAR", {
                img: imgURL,
                orgId: orgProfileData.orgId,
              });

              finalOrg.imgFile = imgFile;
              finalOrg.img = URL.createObjectURL(imgFile);
            } else {
              commit("SET_URL_AVATAR", null);
              if (!finalOrg.img) {
                finalOrg.img = state.currentOrg.img;
              }
            }
            commit("SET_CURRENT_ORG", finalOrg);
          } catch (error) {
            showErrorAPI(error, Org.getOrg);
          }
        }
      } catch (error) {
        showErrorAPI(error, Org.getOrgProfile);
      }
    },
    fetchOrgList: async ({ commit, state }, data = null) => {
      let currentUser;
      let currentOrg;
      let noPlan = false;
      try {
        // Get current user data
        if (!data) {
          const currentUserData = await getCurrentUser();
          if (currentUserData.data?.data) {
            currentUser = currentUserData.data.data;
            localStorage.setItem(
              localStorageKey.currentUserData,
              JSON.stringify(currentUser),
            );
            localStorage.setItem(
              localStorageKey.languageId,
              currentUser.languageId,
            );
          }
        } else {
          currentUser = data;
        }
      } catch (error) {
        showErrorAPI(error, UserRoute.get);
        currentUser = {};
      }

      try {
        // Get current org data
        const orgDetails = await getParentOrg(
          currentUser.currentOrgId || currentUser.orgId,
        );
        const currentOrgSecretRequired = {
          secretRequiredChecklistRequested: !get(
            orgDetails,
            "data.data.secretDisabledChecklistRequested",
            true,
          ),
          secretRequiredPasswordReset: !get(
            orgDetails,
            "data.data.secretDisabledPasswordReset",
            true,
          ),
        };
        state.currentOrgSecretRequired = currentOrgSecretRequired;
        currentOrg = {
          ...orgDetails.data?.data,
        };
        // Set current org plan details
        if (!orgDetails.data?.data?.planDetails?.planId) {
          noPlan = true;
          router.push({ path: homeRoute.homePage });
        }
        commit(
          "SET_CURRENT_ORG_PLAN_DETAILS",
          orgDetails.data?.data.planDetails,
        );
        let currentOrgProfile: any;
        if (!noPlan) {
          currentOrgProfile = await getOrgProfile();
        }
        if (currentOrgProfile) {
          currentOrg = {
            ...currentOrg,
            ...currentOrgProfile.data?.data,
          };
        }

        const avatarImageId = currentOrg?.avatar?.avatarImageFileId;
        const finalOrg = {
          ...currentOrg,
          id: currentOrg.orgId,
          name: currentOrg.nameShort,
          icon:
            currentOrg?.profileData?.avatarImageId || "/img/activeOrg_icon.svg",
          isHome: currentOrg.orgId === currentUser.orgId,
          logoImageFileId:
            currentOrg?.logosm?.logoSmImageFileId ||
            currentOrg?.logolg?.logoLgImageFileId,
          avatarImageId,
        };
        if (finalOrg?.avatarImageId) {
          const res = await getProfileImage(finalOrg?.avatarImageId);
          const imageDetails = res.data.data;
          const img = await getImageData(imageDetails);
          finalOrg.img = URL.createObjectURL(img);
        }
        commit("SET_CURRENT_ORG", finalOrg);
        if (avatarImageId) {
          commit("SET_URL_AVATAR", finalOrg.img);
        } else {
          commit("SET_URL_AVATAR", null);
        }

        // Get list switch orgs
        const orgList: any = await getSwitchOrgs();
        if (orgList.data?.data?.orgs?.length) {
          const formattedOrgList = orgList.data.data.orgs.map((org: any) => {
            return {
              ...org,
              id: org.id,
              name: org.nameShort,
              icon: org.profileData?.avatarImageId || "/img/activeOrg_icon.svg",
              isHome: org.id === currentUser.orgId,
            };
          });
          commit(
            "SET_ORIGIN_ORGS_LIST",
            JSON.parse(JSON.stringify(formattedOrgList)),
          );
          setTimeout(async () => {
            // Get profile image for each org
            const promises = formattedOrgList.map(async (org) => {
              if (
                org?.profileData?.avatarImageId &&
                org.id !== finalOrg.orgId
              ) {
                try {
                  const res = await getProfileImage(
                    org.profileData.avatarImageId,
                    org.id == state.currentOrg.orgId ? null : org.id,
                  );
                  const imageDetails = res.data.data;
                  const imgBlob = await getImageData(imageDetails);
                  org.img = URL.createObjectURL(imgBlob);
                } catch (error) {
                  console.log("error", error);
                }
              }
              if (org.id == finalOrg.orgId) {
                org.img = finalOrg.img;
              }
            });
            await Promise.all(promises);
            // Set parent org data
            if (currentOrg?.idParentOrg) {
              const currentParentOrg = formattedOrgList.find(
                (org) => org.id === currentOrg.idParentOrg,
              );
              const listOrg = formattedOrgList.filter(
                (org) => org.id !== currentOrg.idParentOrg,
              );
              if (!noPlan) {
                try {
                  const profileParent = await getOrgIdProfile(
                    currentParentOrg.id,
                  );
                  if (profileParent.status == 200) {
                    const data = profileParent.data.data;
                    if (
                      data?.logosm?.logoSmImageFileId ||
                      data?.logolg?.logoLgImageFileId ||
                      data?.avatar?.avatarImageFileId
                    ) {
                      const res = await getProfileImage(
                        data?.logosm?.logoSmImageFileId ||
                          data?.logolg?.logoLgImageFileId ||
                          data?.avatar?.avatarImageFileId,
                        data?.orgId,
                      );
                      const imageDetails = res.data.data;
                      const imgBlob = await getImageData(imageDetails);
                      currentParentOrg.imgLogo = URL.createObjectURL(imgBlob);
                    }
                  }
                } catch (error) {
                  showErrorAPI(error, Org.getOrgIdProfile);
                }
              }
              commit("SET_CURRENT_PARENT_ORG", currentParentOrg);
              commit("SET_STATUS_CALL_API_CHECK_PARENT", true);
              commit("SET_ORGS_LIST", listOrg);
            } else {
              commit("SET_ORGS_LIST", formattedOrgList);
              commit("SET_STATUS_CALL_API_CHECK_PARENT", true);
              commit("SET_CURRENT_PARENT_ORG", {});
            }
            EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
          }, 1000);
        }
      } catch (error) {
        commit("SET_ORGS_LIST", []);
        commit("SET_CURRENT_ORG", {});
        showErrorAPI(error, Org.getOrgsSwitch);
      }
    },
    fetchOrgListVerify: async (
      { state },
      payload: { includeArchived: boolean } = { includeArchived: false },
    ) => {
      try {
        const res: any = await getOrgVerify(payload);
        state.orgListVerify = res?.data?.data || [];
        return res?.data?.data || [];
      } catch (error) {
        showErrorAPI(error, Org.getOrgVerify);
        return [];
      }
    },
    fetchAddableOrgList: async ({ commit, state }, ordId: string) => {
      const orgList = await getOrgMembersAddable(state.currentOrg.id || ordId);

      if (orgList.data?.data?.length) {
        const formattedOrgList = orgList.data.data.map((org: any) => {
          return {
            ...org,
            id: org.userId,
            name: `${org.firstName} ${org.lastName}`,
          };
        });
        commit("SET_ADDABLE_ORGS_LIST", formattedOrgList);
      }
    },
    fetchGrantedOrgsList: async ({ commit }) => {
      try {
        const orgList = await getOrgAccessGrantedToOther();
        if (orgList.data?.data?.grantedOrgs?.length) {
          const formattedOrgList = orgList.data.data.grantedOrgs.map(
            (org: any) => {
              return {
                ...org,
                id: org.org2Id,
                name: org.org2NameShort,
              };
            },
          );
          commit("SET_GRANTED_ORGS_LIST", formattedOrgList);
        } else commit("SET_GRANTED_ORGS_LIST", []);
      } catch (error) {
        showErrorAPI(error, Org.getAccessGrantedToOtherOrgs);
      }
    },
    deleteOrg: async ({ commit, state }, orgId: string) => {
      const orgs = state.orgsList.filter(
        (org: IOrgDetails) => org.id !== orgId,
      );
      commit("SET_ORGS_LIST", orgs);
    },
    removeOrgStore: async ({ commit }) => {
      commit("SET_CURRENT_ORG", []);
      commit("SET_ORGS_LIST", []);
      commit("SET_ADDABLE_ORGS_LIST", []);
      commit("SET_GRANTED_ORGS_LIST", []);
    },
    resetMembersPassword: async (_, payload) => {
      const { userIds } = payload;
      try {
        await resetPasswordOrgMembers(userIds);
      } catch (error) {
        showErrorAPI(error, Org.resetPasswordOrgMembers);
      }
    },
    resetMembersMFA: async (_, payload) => {
      const { userIds } = payload;
      try {
        await resetMfaOrgMembers(userIds);
      } catch (error) {
        showErrorAPI(error, Org.postOrgMembersMfaReset);
      }
    },
    resetMembersMFAPasskey: async () => {
      await resetMfaPasskeyOrgMembers();
    },
    reactivateMembers: async (_, payload) => {
      const { userIds } = payload;
      await putOrgMembersActivate(userIds);
    },
    deactivateMembers: async (_, payload) => {
      const { userIds } = payload;
      await postOrgMembersDeactivate(userIds);
    },
    removeMembers: async (_, payload) => {
      const { userIds, isExternal } = payload;
      if (isExternal) {
        // await deleteOrgMembersExternalDelete(userIds);
        await Promise.all(
          userIds.map((id: number) => deleteOneOrgMemberExternalDelete(id)),
        );
      } else {
        await deleteOrgMembersDelete(userIds);
      }
    },
    handleOrgVerifiCallback: async (_, payload) => {
      const res = await postOrgVerifiCallback(payload);
      return res;
    },
    setCurrentOrgPlanDetails: ({ commit }, value) => {
      commit("SET_CURRENT_ORG_PLAN_DETAILS", value);
    },
    postOrgProfile: async ({ state }, payload: { bio: string }) => {
      try {
        await postOrgProfile(payload);
        state.currentOrgProfile.orgBio = payload.bio;
        showSuccessToast(
          getComponentUiText(
            "app-settings-org-profile-update-profile-success-1",
          ),
        );
        return true;
      } catch (error) {
        showErrorAPI(error, Org.postOrgProfile);
        return false;
      }
    },

    getRoleByUserId: async ({ commit }, userId: string) => {
      const res = await getRoleByUserId(userId);
      const data = get(res, "data.data.roles", []);
      data.forEach((role: any) => {
        role.roleName = role.role;
      });
      commit("SET_CURRENT_ROLES_BY_USER", data);
    },

    getPermissionByRoleId: async ({ state }) => {
      try {
        const data = await Promise.all(
          state.listRolesByUser.map((role: any) =>
            getPermissionLevelDetailsOfRoleType(role.roleTypeId),
          ),
        );
        const value = data.sort(
          (a: any, b: any) =>
            b.data.data.permissionLevelValue - a.data.data.permissionLevelValue,
        );
        state.maximunPermissionLevelData = value[0].data.data;

        return state.maximunPermissionLevelData;
      } catch (error) {
        showErrorAPI(error, Org.getPermissionLevelDetailsOfRoleType);
        return null;
      }
    },

    setOrgRoles: ({ commit }, orgRoles) => {
      commit("SET_ORG_ROLES", orgRoles);
    },
    fetchOrgRoles: async ({ state }) => {
      try {
        const roleResponse = await getOrgRoles();
        state.orgRoles = roleResponse.data.data;
        return roleResponse;
      } catch (error: any) {
        return error;
      }
    },

    restoreUser: async (_, userId: string) => {
      try {
        await restoreUser(userId);
      } catch (error) {
        showErrorAPI(error, Org.restoreUser);
      }
    },
  },
};
export default orgModule;
